import { createMutationHook } from '../client';
import { givePrivacyConsentPublic } from '../services/EnergyProfilePublicService';

export const useEnergyProfilePublicGivePrivacyConsentPublic = createMutationHook(givePrivacyConsentPublic, {
  injectables: ['label', 'customerId', 'businessUnit'],
  flattenData: false,
});
